<template>
  <StandardSearchPageView
    ref="table"
    :colNum="3"
    :columns="columns"
    :queryParams="queryParams"
    :searchOptions="searchOptions"
    :requestPromise="loadDataList"
  >
    <template v-slot:productInfoSlot="{ text }">
      <ellipsis :length="40" tooltip>{{ text }}</ellipsis>
    </template>
    <template v-slot:rateplanInfoSlot="{ text }">
      <ellipsis :length="60" tooltip>{{ text }}</ellipsis>
    </template>
  </StandardSearchPageView>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'ProductUpdateComponent',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {},
      searchOptions: [
        {
          name: '商品ID',
          key: 'productId',
          type: 'input',
          placeholder: '请输入商品ID'
        },
        {
          name: '商品名称',
          key: 'productName',
          type: 'input',
          placeholder: '请输入商品名称'
        }
      ],
      columns: [
        {
          title: '商品ID',
          dataIndex: 'productId',
          width: '180px'
        },
        {
          title: '大横琴酒店代码',
          dataIndex: 'hotelCode',
          width: '140px'
        },
        {
          title: '商品信息',
          dataIndex: 'productInfo',
          width: '220px',
          scopedSlots: { customRender: 'productInfoSlot' }
        },
        {
          title: '价格计划信息',
          dataIndex: 'rateplanInfo',
          width: '380px',
          scopedSlots: { customRender: 'rateplanInfoSlot' }
        },
        {
          title: '来源',
          dataIndex: 'sourceName',
          width: '120px'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '180px'
        }
      ]
    }
  },
  methods: {
    buildListParams(params = {}) {
      const { limitDto = {}, productId, productName } = params
      const requestParams = {
        merchantId: this.$store.getters.userInfo.merchantId,
        pageNum: limitDto.pageNum || 1,
        pageSize: limitDto.pageSize || 10
      }
      if (productId) requestParams.productId = Number(productId)
      if (productName) requestParams.productName = productName
      return requestParams
    },
    loadDataList(params) {
      return this.getHttpServices().getSourceService()
        .post('dahengqin/platform/productUpdate_list', this.buildListParams(params))
        .then(res => ({
          data: res.data,
          totalCount: res.totalCount,
          pageCount: res.pageCount
        }))
    }
  }
}
</script>
